/* Storefront-only fallback while the official channels are being connected.
 * Purchase / checkout events belong to Shopify's native channel integrations,
 * never to a checkout-button click. Native mode disables our destination tags.
 * GTM loads in the layout. This bridge also updates its consent from Shopify.
 */
(function () {
  "use strict";
  if (window.__amaAdTrackingBound) return;
  window.__amaAdTrackingBound = true;

  var config = window.amaAdTrackingConfig || {};
  var dataLayer = (window.dataLayer = window.dataLayer || []);
  var googleTheme = config.googleSource === "theme";
  var googleConsent = googleTheme || Boolean(config.gtmId);
  var metaTheme = config.metaSource === "theme";
  var ga4Id = /^G-[A-Z0-9]+$/.test(config.ga4Id || "") ? config.ga4Id : "";
  var adsId = /^AW-\d+$/.test(config.googleAdsId || "") ? config.googleAdsId : "";
  var pixelId = /^\d+$/.test(config.metaPixelId || "") ? config.metaPixelId : "";
  var ga4Loaded = false;
  var adsLoaded = false;
  var googleStarted = false;
  var pixelOwned = false;
  var viewSent = { layer: false, ga4: false, meta: false };

  if (googleConsent) {
    window.gtag = window.gtag || function () { dataLayer.push(arguments); };
  }

  function consent(category) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return Boolean(privacy && privacy[category]()); }
    catch (error) { return false; }
  }
  function analyticsAllowed() { return consent("analyticsProcessingAllowed"); }
  function marketingAllowed() { return consent("marketingAllowed"); }
  function analyticsActive() { return googleTheme && ga4Loaded && analyticsAllowed(); }
  function metaActive() { return metaTheme && pixelOwned && marketingAllowed(); }

  function loadScript(id, src) {
    if (document.getElementById(id)) return;
    var script = document.createElement("script");
    script.id = id;
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }
  function updateConsent() {
    var analytics = analyticsAllowed();
    var marketing = marketingAllowed();
    if (googleConsent) {
      window.gtag("consent", "update", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied",
      });
    }
    if (pixelOwned) window.fbq("consent", marketing ? "grant" : "revoke");
    dataLayer.push({ event: "ama_consent_update", ama_analytics_consent: analytics, ama_marketing_consent: marketing });
  }
  function loadGoogleTag(id) {
    loadScript("ama-google-tag", "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(id));
    if (!googleStarted) {
      googleStarted = true;
      window.gtag("js", new Date());
    }
  }
  function loadPixel() {
    // Another integration must not receive a second init / second set of events.
    if (!metaTheme || !pixelId || window.fbq || !marketingAllowed()) return;
    var fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    window._fbq = window._fbq || fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    pixelOwned = true;
    loadScript("ama-meta-pixel", "https://connect.facebook.net/en_US/fbevents.js");
    fbq("consent", "grant");
    fbq("init", pixelId);
    fbq("track", "PageView");
  }
  function roundMoney(value) { return Math.round((value + Number.EPSILON) * 100) / 100; }
  function commerceEvent(name, ecommerce) {
    if (analyticsActive() || metaActive()) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({ event: name, ecommerce: ecommerce });
    }
    if (analyticsActive()) {
      // Explicit destination prevents accidental routing to an Ads account.
      window.gtag("event", name, Object.assign({ send_to: ga4Id }, ecommerce));
    }
  }
  function metaCommerce(name, ecommerce) {
    if (!metaActive()) return;
    var items = ecommerce.items;
    window.fbq("track", name, {
      content_type: "product",
      content_ids: items.map(function (item) { return item.item_id; }),
      contents: items.map(function (item) { return { id: item.item_id, quantity: item.quantity, item_price: item.price }; }),
      num_items: items.reduce(function (total, item) { return total + item.quantity; }, 0),
      currency: ecommerce.currency,
      value: ecommerce.value,
    });
  }
  function productView() {
    var product = config.product;
    if (!product || !Number.isFinite(Number(product.value)) || Number(product.value) < 0) return;
    var ecommerce = { currency: config.currency, value: Number(product.value), items: [{
      item_id: String(product.variantId || product.id), item_name: product.title,
      item_brand: product.vendor || undefined, price: Number(product.value), quantity: 1,
    }] };
    if ((analyticsActive() || metaActive()) && !viewSent.layer) {
      dataLayer.push({ ecommerce: null }, { event: "view_item", ecommerce: ecommerce });
      viewSent.layer = true;
    }
    if (analyticsActive() && !viewSent.ga4) {
      window.gtag("event", "view_item", Object.assign({ send_to: ga4Id }, ecommerce));
      viewSent.ga4 = true;
    }
    if (metaActive() && !viewSent.meta) {
      metaCommerce("ViewContent", ecommerce);
      viewSent.meta = true;
    }
  }
  function addToCart(event) {
    if (!analyticsActive() && !metaActive()) return;
    // A cart quantity edit / deletion is not a successful add operation.
    if (!event || ["product-form", "ama-program", "ama-add-many"].indexOf(event.source) === -1) return;
    var response = event.cartData;
    if (!response || response.status) return;
    var requested = Object.create(null);
    (event.addedQuantities || []).forEach(function (item) {
      var quantity = Number(item.quantity);
      if (Number.isInteger(quantity) && quantity > 0) {
        var id = String(item.id);
        requested[id] = (requested[id] || 0) + quantity;
      }
    });
    var seen = Object.create(null);
    var lines = Array.isArray(response.items) ? response.items : [response];
    var items = [];
    lines.forEach(function (line) {
      var id = line.variant_id || line.id;
      var key = line.key || String(id);
      var quantity = requested[String(id)];
      if (!id || seen[key] || !quantity) return;
      seen[key] = true;
      // final_line_price is the entire existing cart line, not a unit price.
      // Preserve zero-priced gifts; do not use || for monetary fallbacks.
      var cents = line.final_price;
      if (cents == null && line.final_line_price != null && Number(line.quantity) > 0) {
        cents = Number(line.final_line_price) / Number(line.quantity);
      }
      if (cents == null) cents = line.price;
      if (cents == null || !Number.isFinite(Number(cents)) || Number(cents) < 0) return;
      items.push({ item_id: String(id), item_name: line.product_title || line.title,
        item_brand: line.vendor || undefined, item_variant: line.variant_title || undefined,
        price: roundMoney(Number(cents) / 100), quantity: quantity });
    });
    if (!items.length) return;
    var ecommerce = { currency: config.currency, items: items,
      value: roundMoney(items.reduce(function (total, item) { return total + item.price * item.quantity; }, 0)) };
    commerceEvent("add_to_cart", ecommerce);
    metaCommerce("AddToCart", ecommerce);
  }
  function loadTags() {
    updateConsent();
    if (googleTheme && analyticsAllowed() && ga4Id && !ga4Loaded) {
      ga4Loaded = true;
      loadGoogleTag(ga4Id);
      window.gtag("config", ga4Id);
    }
    if (googleTheme && marketingAllowed() && adsId && !adsLoaded) {
      adsLoaded = true;
      loadGoogleTag(adsId);
      window.gtag("config", adsId);
    }
    loadPixel();
    productView();
  }
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Tracking must never prevent cart rendering / checkout on script errors.
      try { addToCart(event); } catch (error) { console.warn("Amalife tracking event skipped", error); }
    });
  }
  document.addEventListener("visitorConsentCollected", loadTags);
  window.addEventListener("pageshow", loadTags);
  if (window.Shopify && window.Shopify.customerPrivacy) loadTags();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
      if (!error) loadTags();
    });
  }
})();
